module.exports = __webpack_public_path__ + "img/ROBOTICS_DT.cb2a493b.png";